module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Clothes/Shoes-ddd622e54329353ca17ee369987ca06b.svg";